import { useTranslation } from 'react-i18next'

import { getQaSelector } from '../../../../../../../utils/common'
import Text from '../../../../../../Text'
import { useWidgetContext } from '../../../../../../Widget'
import { LISTING_PROFILE_EDIT_BLOCK } from '../../../RentalPortalListingProfile.constants'
import { useListingProfileContext } from '../../../RentalPortalListingProfile.hooks'
import { useListingProfileBlockToEdit } from '../../RentalPortalListingProfileExpose.hooks'
import { QA_NAME_LISTING_PROFILE_DESCRIPTION_VALUE } from '../RentalPortalListingProfileDescriptionWidget.constants'
import { RentalPortalListingProfileDescriptionWidgetForm } from '../RentalPortalListingProfileDescriptionWidgetForm'

import * as styles from './RentalPortalListingProfileDescriptionWidgetContent.module.css'

function RentalPortalListingProfileDescriptionWidgetContent({ containerRef }) {
  const { t } = useTranslation()

  const { handleDisableEditMode, isEditMode } = useWidgetContext()

  const { listingData } = useListingProfileContext()

  useListingProfileBlockToEdit({
    blockId: LISTING_PROFILE_EDIT_BLOCK.description,
    containerRef,
  })

  return isEditMode ? (
    <RentalPortalListingProfileDescriptionWidgetForm
      onClose={handleDisableEditMode}
      onSuccess={handleDisableEditMode}
    />
  ) : listingData?.description ? (
    <div
      {...getQaSelector({ value: QA_NAME_LISTING_PROFILE_DESCRIPTION_VALUE })}
      className={styles.RentalPortalListingProfileDescriptionWidgetContent}
      dangerouslySetInnerHTML={{ __html: listingData.description }}
    />
  ) : (
    <Text isSecondary>{t('Select.NoDataKey')}</Text>
  )
}

export default RentalPortalListingProfileDescriptionWidgetContent
